import { isNil } from 'lodash'

class StorageManagerError extends Error {
  name = 'StorageManagerError'
}

class StorageManager {
  constructor () {
    this.adapter = null
  }

  setStorageAdapter (adapter) {
    this.adapter = adapter
  }

  getItem (key) {
    if (this.adapter) {
      return this.adapter.getItem(key)
    }

    throw new StorageManagerError('Unable to get item. No adapter provided')
  }

  setItem (key, value) {
    if (this.adapter) {
      return this.adapter.setItem(key, value)
    }

    throw new StorageManagerError('Unable to set item. No adapter provided')
  }

  removeItem (key) {
    if (this.adapter) {
      return this.adapter.removeItem(key)
    }

    throw new StorageManagerError('Unable to remove item. No adapter provided')
  }

  async storeDataByStorageKeys (data, storageKeys, prefix) {
    for (const storageKey of storageKeys) {
      const dataByKey = data[storageKey]

      if (!isNil(dataByKey)) {
        this.setItem(
          `${prefix}-${storageKey}`,
          dataByKey
        )
      }
    }
  }

  async getDataByStorageKeys (storageKeys, prefix) {
    const data = {}

    for (const storageKey of storageKeys) {
      const dataByKey = await this.getItem(
        `${prefix}-${storageKey}`
      )

      if (!isNil(dataByKey)) {
        if (dataByKey === 'false') {
          data[storageKey] = false
        }

        switch (dataByKey) {
          case 'false':
            data[storageKey] = false
            break
          case 'true':
            data[storageKey] = true
            break
          default:
            data[storageKey] = dataByKey
        }
      }
    }

    return data
  }
}

const storage = new StorageManager()

export default storage
